import { APIProvider } from '@vis.gl/react-google-maps';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Provider } from 'react-redux';

import AppTheme from 'AppTheme';
import ErrorBoundary from 'ErrorBoundary';
import { EnvironmentVariable } from 'enums/curo/EnvironmentVariable';
import { envs } from 'envs';
import { initGTM } from 'init-gtm';
import { initSentry } from 'init-sentry';
import 'product_modules';
import CuroAppRouter from 'routes/CuroAppRouter';

import './index.scss';
import { store } from './store';

initSentry();
initGTM();

// CURO-TODO remove after testing
// @ts-ignore
window.getEnvs = function () {
  return { envs: process.env };
};

ReactDOM.render(
  <ErrorBoundary>
    <StrictMode>
      <Provider store={store}>
        <AppTheme>
          <GoogleReCaptchaProvider reCaptchaKey={envs[EnvironmentVariable.GoogleReCaptchaSiteKey]}>
              <APIProvider apiKey={envs[EnvironmentVariable.GoogleMapsApiKey]}>
                <CuroAppRouter />
              </APIProvider>
          </GoogleReCaptchaProvider>
        </AppTheme>
      </Provider>
    </StrictMode>
  </ErrorBoundary>,
  document.getElementById('root'),
);
